module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-2.b7b02093.jpg";